import { render } from "./UserTerms.vue?vue&type=template&id=21d5a00c"
import script from "./UserTerms.vue?vue&type=script&setup=true&lang=js"
export * from "./UserTerms.vue?vue&type=script&setup=true&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/views/static-pages/UserTerms.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "21d5a00c"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('21d5a00c', __exports__)) {
    api.reload('21d5a00c', __exports__)
  }
  
  module.hot.accept("./UserTerms.vue?vue&type=template&id=21d5a00c", () => {
    api.rerender('21d5a00c', render)
  })

}


export default __exports__